import React, { useEffect, useState } from "react";
import { TENANT_BUCKET, HEADER_MENU_DATA } from '../../common/constants'
import { useTranslation } from 'react-i18next';
import ImageWithPlaceholder from '../../components/ImageWithPlaceholder'
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

const Dynamic2 = (props) => {
  const { desktopToggle, mobileToggle, label, id, imageType, supportLanguage, linkTo, titleToggle, addContainer } = props;
  const { t, i18n } = useTranslation();
  const getLastLanguage = localStorage.getItem('current_language');
  // const [setGetLanguage, getLanguage] = useState(getLastLanguage ?? i18n.resolvedLanguage)



  const getLink = HEADER_MENU_DATA[linkTo] ?? ''
  // console.log('getLink:', getLink)


  // useEffect(() => {
  //   setGetLanguage(i18n.resolvedLanguage)
  // }, [i18n.resolvedLanguage,setGetLanguage])

  // console.log('image template2', `${TENANT_BUCKET}/section/${id}_${getLastLanguage ?? i18n.resolvedLanguage}.${imageType ?? 'png'}`)

  if ((desktopToggle || mobileToggle) === true) {
    return (
      <>
        <section className={`section dynamic2 ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"}`} id={`${id}`}>
          <div className={`${addContainer ? 'container' : ''}`}>
            {titleToggle ?
              <div className={`section_header`}>
                <div className="font_h2 section_title">
                  <img src={`${TENANT_BUCKET}/icon/${id}_title_icon.png`} alt="title icon" />
                  {label && t(label)}</div>
              </div>
              : <></>}

            <Link to={`${getLink !== '' ? getLink.url : '#'}`} style={{ cursor: getLink !== '' ? 'pointer' : 'default' }}>

              {supportLanguage ?
                <ImageWithPlaceholder src={`${TENANT_BUCKET}/section/${id}_${getLastLanguage ?? i18n.resolvedLanguage}.${imageType ?? 'png'}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x3.png`} alt={`${label}`} /> :
                <ImageWithPlaceholder src={`${TENANT_BUCKET}/section/${id}.${imageType ?? 'png'}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x3.png`} alt={`${label}`} />}


            </Link>
          </div>
        </section>

      </>
    );
  }

}



export default Dynamic2;
